import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'ellipses'
})
export class EllipsesPipe implements PipeTransform {
    transform(value: any, args?: any): any {
        if (isNaN(args) || args <= 0) {
            return value;
        }
        if (value && value.length > args) {
            value = value.substring(0, args);
            return value;
        }
        return value;
    }

}